module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer008"
    }
  }, [_c('p', {
    staticClass: "CT"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_vm._v("xv")])]), _vm._v(" "), _c('p', {
    staticClass: "_disc",
    attrs: {
      "id": "_idParaDest-6"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor003"
    }
  }), _vm._v(" Disclaimer")]), _vm._v(" "), _c('p', {
    staticClass: "tx-ni"
  }, [_vm._v("Anyone reading this book or listening to it in any form hereby acknowledges and is tacitly assumed to have read this disclaimer. This publication contains the opinions and ideas of the author. The information provided herein cannot be given to any degree of certainty or guarantee, and you should not rely on it to make any decision that would affect your legal, financial, or medical condition. If any condition, inquiry, or situation involves the law, finance, or medicine, then you should seek the advice of a licensed or qualified legal, financial, or medical professional. These methods can only facilitate how you cope spiritually with a given situation.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Furthermore, certain jurisdictions require that those in the field of fortune-telling must state "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("for entertainment purposes only")]), _vm._v(". To the extent you live in such a jurisdiction, consider yourself on notice thereof. The author and publisher and all of their affiliates specifically disclaim all responsibility for any liability, loss, or risk, personal or otherwise, that is incurred as a consequence, directly or indirectly, of the use and application of any of the contents of this book. The author has endeavored to recreate events, locales, and conversations from her memories and conversations with those involved. Therefore, it reflects her present recollections of experiences over time. In order to maintain anonymity, some names and characteristics have been changed, some events have been compressed, and some dialogue has been recreated.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d6c91db2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Disc.vue
// module id = 75
// module chunks = 0